function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLogoAmpere(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "uc-svg": "uc-social"
  }, props), React.createElement("path", {
    d: "M19 3a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14zm-5.453 4.69l-2.537 4.996-.082.012a6.694 6.694 0 00-4.83 3.355l-.134.253.008.004h1.272a5.58 5.58 0 011.925-1.834l.265-.142.112-.055c.175-.083.351-.157.53-.22l.284-.093-1.187 2.338.012.006h1.235l3.127-6.157 1.695 3.338-.063-.035a6.731 6.731 0 00-1.569-.623l-.33-.076-.526 1.04a5.579 5.579 0 013.735 2.284l.154.229h1.27l.01-.004-4.376-8.616z",
    fill: dark,
    fillRule: "evenodd"
  }));
}

SvgLogoAmpere.clsName = 'icon-uc-social__logo-ampere';
SvgLogoAmpere.remarkName = 'unknown';
export default SvgLogoAmpere;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/uc-social/svgr/LogoAmpere.js
// module id = 2228
// module chunks = 17 18